import { skillsApi } from '../services/api';
import { useAlert } from '../contexts/AlertContext';

const useFeedbackActionsManagement = (assignment, setAssignment, myReviewer, employeeId) => {
  const { showAlert } = useAlert();

  const handleFeedbackActionsChange = async (actionType, comments) => {
    try {
      // Only proceed if it's the current reviewer's feedback and feedback not already attached
      if (!myReviewer?.feedbackAttachedAt && employeeId === myReviewer?.employee?.id) {
        
        // Get current reviewer from assignment
        const currentReviewer = assignment?.reviewers?.find(reviewer => 
          reviewer.employee.id === employeeId && reviewer.id === myReviewer?.id
        );
        
        // Get existing feedback to preserve other comments
        const existingFeedback = currentReviewer?.feedbackOnDemand || {};
        
        // Create feedback data preserving existing comments and only updating the changed one
        const feedbackData = {
          startComments: actionType === 'start' ? comments : (existingFeedback.startComments || ''),
          stopComments: actionType === 'stop' ? comments : (existingFeedback.stopComments || ''),
          continueComments: actionType === 'continue' ? comments : (existingFeedback.continueComments || '')
        };

        await skillsApi.setFeedbackActions(
          myReviewer.id,
          feedbackData
        );
        
        // Update assignment state to reflect the change (like comments do with competencies)
        setAssignment(prev => ({
          ...prev,
          reviewers: prev.reviewers.map(reviewer => 
            reviewer.id === myReviewer.id 
              ? {
                  ...reviewer,
                  feedbackOnDemand: {
                    ...reviewer.feedbackOnDemand,
                    [actionType + 'Comments']: comments
                  }
                }
              : reviewer
          )
        }));
        
        return Promise.resolve(); // Return resolved promise on success
      }
      return Promise.resolve(); // Still resolve if we didn't need to save
    } catch (error) {
      console.error('Error saving feedback actions:', error);
      return Promise.reject(error); // Reject promise on error
    }
  };

  return {
    handleFeedbackActionsChange
  };
};

export default useFeedbackActionsManagement; 